//deps
import React, { memo, ReactElement } from "react";

//internal-deps
import { AUTOPAY_PAYMENT_FAILURE_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";

//style
import styles from "./Shimmer.scss";

const Shimmer = (): ReactElement => {
    return (
        <div className={styles.container} data-testid={AUTOPAY_PAYMENT_FAILURE_SCREEN_TEST_IDS.SHIMMER_CONTAINER}>
            <div className={styles.circle} />
            <div className={styles.smallLine} />
            <div className={styles.line} />
        </div>
    );
};

export default memo(Shimmer);
